/* Wellivea components: carousels, announcement rotation, reduced-motion handling. */
(function () {
  if (window.Wellivea) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(wrap) {
    if (wrap.dataset.wvReady) return;
    wrap.dataset.wvReady = '1';
    var track = wrap.querySelector('[data-wv-track]');
    var prev = wrap.querySelector('[data-wv-prev]');
    var next = wrap.querySelector('[data-wv-next]');
    var nav = prev ? prev.parentElement : null;
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (nav) nav.hidden = max < 8;
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft > max - 8;
    }
    function go(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAnnounce(bar) {
    if (bar.dataset.wvReady) return;
    bar.dataset.wvReady = '1';
    var track = bar.querySelector('[data-wv-track]');
    var secs = parseInt(bar.getAttribute('data-speed') || '0', 10);
    if (!track || reduce || !secs || track.children.length < 2) return;
    var i = 0;
    var paused = false;
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (e) {
      bar.addEventListener(e, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      bar.addEventListener(e, function () { paused = false; });
    });
    setInterval(function () {
      if (paused || document.hidden || track.scrollWidth <= track.clientWidth + 4) return;
      i = (i + 1) % track.children.length;
      track.scrollTo({ left: track.children[i].offsetLeft, behavior: 'smooth' });
    }, secs * 1000);
  }

  function initVideos(root) {
    if (!reduce) return;
    root.querySelectorAll('.wv video[autoplay]').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
      v.controls = true;
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-wv-rail]').forEach(initRail);
    root.querySelectorAll('[data-wv-announce]').forEach(initAnnounce);
    initVideos(root);
    document.dispatchEvent(new CustomEvent('wellivea:init', { detail: { root: root } }));
  }

  window.Wellivea = { init: init, reduceMotion: reduce };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
